import { useServices, useToast } from '@/app/providers';
import type { UnitCobranza } from '@yawi/types';
import { useState } from 'react';

interface UseBulkAccessArgs {
  patchMany: (ids: string[], patch: Partial<UnitCobranza>) => void;
  onChanged?: () => void;
  clearSelection?: () => void;
}

/**
 * Acción bulk sin update optimista (puede afectar a muchas unidades): espera
 * confirmación del servidor antes de reflejar el cambio en la tabla.
 */
export function useBulkAccess({ patchMany, onChanged, clearSelection }: UseBulkAccessArgs) {
  const { cobranzaRepo } = useServices();
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  const run = async (ids: string[], isBlocked: boolean) => {
    if (ids.length === 0) return;
    setLoading(true);
    try {
      const { updated } = await cobranzaRepo.bulkUpdateAccess(ids, isBlocked);
      patchMany(ids, { isBlocked });
      onChanged?.();
      clearSelection?.();
      toast.success(
        `${updated} unidad${updated === 1 ? '' : 'es'} ${isBlocked ? 'bloqueada' : 'habilitada'}${updated === 1 ? '' : 's'}`,
      );
    } catch {
      toast.error('No se pudo actualizar el acceso en bloque');
    } finally {
      setLoading(false);
    }
  };

  return { run, loading };
}
